<template>
	<div class="d-none d-md-flex align-items-center text-primary h4 mb-0 px-2">
		<b>{{ $route.name }}</b>
	</div>
</template>
